var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',{attrs:{"value":_vm.active,"color":"red","dot":"","overlap":"","offset-x":12,"offset-y":12}},[_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","color":_vm.active ? 'primary' : ''}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',[_vm._v("mdi-filter-variant")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }